<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Create a tab on a profile page that can be loaded separately
    *
    * @since 20230627
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2023 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <div v-if="hasLoaded && error_occured">
            <span class="text-danger">An Error occurred loading this section!</span>
        </div>
        <div v-else-if="hasLoaded">
            <slot name="profile_page" v-bind:data="data" v-bind:profilePage="profilePage"></slot>
            <button v-if="showRefreshButton" type="button" class="btn btn-outline-dark float-right" @click="refresh(true)">Refresh Data <i class="fas fa-sync"></i></button>    
        </div>
        <div v-else class="p-3">
            Loading <i class="fa fa-sync fa-spin fa-lg"></i> <a v-if="!loading" href="#" onclick="return false" @click="refresh(true)">Retry</a><br />
            <progress-bar v-if="total > 0" :max="total" :hide-key="true" :bars="[{'name': ' / ' + total +  ' progress', 'value': progress}]"></progress-bar>
        </div>
    </div>
</template>

<script>
    import loadcomponents from './loadcomponents'
    export default{
        props: {
            //the forms to display
            loaded: {
                type: Boolean,
                default: false
            },
            //js scripts to load
            scriptsToLoad: {
                type: Array
            },
            initialData: {
                type: Object|Array
            },
            logic: {
                type: String,
                default: ''
            },
            graph: {
                type: String,
                default: ''
            },
            //the report params
            reportParams: {
                type: Object
            },
            //the student id
            studentId: {
                type: Number,
                default: 0
            },
            showRefreshButton: {
                type: Boolean,
                default: true
            },
            refreshStart: {
                type: Boolean,
                default: false
            }
        },
        //loads after components have loaded
        mounted() {
            if(this.placement_year == -2){
                var today = new Date();
                this.placement_year = today.getFullYear();
                if(today.getMonth() < 7){
                    this.placement_year--;
                }
            }
            if(this.loaded){
                var self = this;
                loadcomponents.loadComponents(this.scriptsToLoad, function(){
                    self.hasLoaded = true;
                });
            } else {
                this.refresh(this.refreshStart);
            }
        },
        data() {
            return {
                data: this.initialData !== undefined && this.initialData !== null && this.initialData['student_' + this.studentId] !== undefined ? this.initialData['student_' + this.studentId] : this.initialData,
                hasLoaded: false,
                loading: false,
                listenJobId: null,
                progress: 0,
                total: 0,
                jobRoute: '',
                error_occured: false,
                //the placement year for searching
                placement_year: this.reportParams.placement_year !== undefined ? this.reportParams.placement_year : -2,
                //the school for searching
                school: this.reportParams.school !== undefined ? this.reportParams.school : 0,
                student_id: this.reportParams.student_id !== undefined ? this.reportParams.student_id : 0,
                profilePage: this
            }
        },
        computed: {

        },
        methods: {
           /**
             * loads in the graph data from the url
             * 
             * @param boolean reload if true, it reloads the cache, otherwise gets from cache
             * 
             * @return Array an array of attendance
             */
            load_data: async function(reload=false) {
                if(this.listenJobId !== null){
                    clearTimeout(this.listenJobId);
                    this.listenJobId = null;
                }
                this.error_occured = false;
                this.progress = 0;
                this.total = 0;
                try {
                    this.$reportJobs.push({
                        startJob: true,
                        logic: this.logic,
                        graph: this.graph,
                        object: this,
                        studentId: this.studentId,
                        params: { 
                            name: "something",
                            reload: reload,
                            placement_year: this.placement_year,
                            school: this.school,
                            student_id: this.student_id
                        }
                    });
                } catch(error) {
                    this.error_occured = true;
                    console.log('An error occurred loading the profile page: ' + this.graph);
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                    this.loading = false;
                    this.hasLoaded = true;
                }
            },
            setJobProgress: function(data){
                this.progress = data.progress;
                this.total = data.total;
                this.jobRoute = data.jobRoute;
            },
            setJobComplete: function(data){
                if(data.graphData['student_' + this.studentId] !== undefined){
                    this.data = data.graphData['student_' + this.studentId];
                    if(data.graphData['student_global'] !== undefined){
                        for (const key in data.graphData['student_global']) {
                            if (data.graphData['student_global'].hasOwnProperty(key)) {
                                this.data[key] = data.graphData['student_global'][key];
                            }
                        }
                    }
                } else {
                    console.log('An error occurred loading the profile page');
                    console.log('no student id section returned for: ' + this.studentId);
                    this.error_occured = true;
                }
                this.loading = false;
                this.jobRoute = '';
                var self = this;
                loadcomponents.loadComponents(this.scriptsToLoad, function(){
                    self.hasLoaded = true;
                });
            },
            setJobError: function(data){
                this.error_occured = true;
                console.log('An error occurred loading the profile page');
                if(data.error !== undefined){
                    console.log(data.error);
                }
                this.loading = false;
                this.hasLoaded = true;
                this.jobRoute = '';
            },
            /**
             * refreshes the chart from the url
             * 
             * @param boolean reload if true, it reloads the cache, otherwise gets from cache
             */
            refresh: function(reload=false){
                if(this.loading){
                    for(var i=0; i<this.$reportJobs.length; i++){
                        if(this.$reportJobs[i].object !== undefined && this.$reportJobs[i].object !== null && this.$reportJobs[i].object.graphId !== undefined && this.$reportJobs[i].object.graphId == this.graphId){
                            this.$reportJobs[i].object = null;
                        }
                    }
                }
                this.loading = true;
                this.hasLoaded = false;
                this.load_data(reload);
            },
        }
    }
</script>